import React, { useState } from 'react';
import {
  Table, TableRow, TableCell, TableHead, TableBody,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useEffectAsync } from '../reactHelper';
import { useTranslation } from '../common/components/LocalizationProvider';
import PageLayout from '../common/components/PageLayout';
import CollectionFab from '../settings/components/CollectionFab';
import CollectionActions from '../settings/components/CollectionActions';
import TableShimmer from '../common/components/TableShimmer';
import { useSuperManager } from '../common/util/permissions';
import SearchHeader, { filterByKeyword } from '../settings/components/SearchHeader';
import RatesMenu from './components/RatesMenu';
import { centToEur } from '../common/util/converter';

const useStyles = makeStyles((theme) => ({
  columnAction: {
    width: '1%',
    paddingRight: theme.spacing(1),
  },
}));

const PricesPage = () => {
  const classes = useStyles();
  const t = useTranslation();
  const superManager = useSuperManager();

  const [timestamp, setTimestamp] = useState(Date.now());
  const [items, setItems] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [loading, setLoading] = useState(false);

  useEffectAsync(async () => {
    setLoading(true);
    try {
      const response = await fetch('/api/prices');
      if (response.ok) {
        setItems(await response.json());
      } else {
        throw Error(await response.text());
      }
    } finally {
      setLoading(false);
    }
  }, [timestamp]);

  return (
    <PageLayout menu={<RatesMenu />} breadcrumbs={['prices']}>
      <SearchHeader keyword={searchKeyword} setKeyword={setSearchKeyword} />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={classes.columnAction} />
            <TableCell>{t('sharedName')}</TableCell>
            <TableCell>{t('price')}</TableCell>
            <TableCell>{t('um')}</TableCell>
            <TableCell>{t('priceUnlock')}</TableCell>
            <TableCell>{t('endHour')}</TableCell>
            <TableCell>discount25</TableCell>
            <TableCell>discount6+</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!loading ? items.filter(filterByKeyword(searchKeyword)).map((item) => (
            <TableRow key={item.id}>
              <TableCell className={classes.columnAction} padding="none">
                <CollectionActions
                  itemId={item.id}
                  editPath="/rates/price"
                  endpoint="prices"
                  setTimestamp={setTimestamp}
                />
              </TableCell>
              <TableCell>{item.name}</TableCell>
              <TableCell>{`${centToEur(item.price)} €`}</TableCell>
              <TableCell>{item.um}</TableCell>
              <TableCell>{`${centToEur(item.priceunlock)} €`}</TableCell>
              <TableCell>{item.endHour}</TableCell>
              <TableCell>{`${centToEur(item.attributes.discount25) || 0} €`}</TableCell>
              <TableCell>{`${centToEur(item.attributes['discount6+']) || 0} €`}</TableCell>
            </TableRow>
          )) : (<TableShimmer columns={3} endAction />)}
        </TableBody>
      </Table>
      {superManager && (<CollectionFab editPath="/rates/price" />)}
    </PageLayout>
  );
};

export default PricesPage;
